import React, { FC, Fragment } from 'react';
import { KeyValueProp, LeadQuestion, OperationQuestion } from '../..';
import {
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent,
  Wrapper,
} from './AdditionalListContentUI';

interface QuestionnaireContentProp {
  questions: LeadQuestion[] | OperationQuestion[];
}

export const QuestionnaireContent: FC<QuestionnaireContentProp> = (props) => {
  const { questions } = props;

  const renderAnswer = (value: boolean | string | KeyValueProp | null): string => {
    if (typeof value === 'boolean') {
      return value ? 'Ja' : 'Nein';
    } else if (typeof value === 'object') {
      return renderAnswer(value.value);   // show display name
    } else if (typeof value === 'string' && value.length > 0) {
      return value;
    }
    return '(keine Angabe)';
  };

  const renderBold = (bold: boolean, markup: any) => {
    return bold ? <strong>{ markup }</strong> : markup;
  }

  const renderItalic = (italic: boolean, markup: any) => {
    return italic ? <i>{ markup }</i> : markup;
  }

  return (
    <Wrapper>
      <DataWrapper>
      {
        questions && questions.length > 0 ? questions.map((question, index) => {
          return (
            <Fragment key={index}>
              <DataRow>
                <DataRowHeader>{ renderBold(question.required, question.label) }</DataRowHeader>
                <DataRowContent>{ renderBold(question.required, renderAnswer(question.value)) }</DataRowContent>
                {/*<DataRowContent>{ renderBold(question.required, renderItalic(!question.answered, renderAnswer(question.value))) }</DataRowContent>*/}
              </DataRow>
              <AdditionalItemDivider />
            </Fragment>
          );
        }) : 'Keine Antworten gefunden.'
      }
      </DataWrapper>
    </Wrapper>
  );
};
